import { Card, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import AssessmentInfo from "./widgets/assessmentInfo";
import QuestionBox from "./widgets/questionBox";
import Countdown from "react-countdown";
import axios from "axios";
import { io } from "socket.io-client";
import { API_ENDPOINT, HEADER_TOKEN } from "../../../constants/constants";
import appLogo from "../../../assets/svgs/logo.svg";
import CircleTimer from "./widgets/circleTimer";
import {
  answerExists,
  getAnswers,
  deleteCandidate,
  getCandidateName,
  isCandidateExists,
  saveAnswers,
  shuffleFisherYates,
  getRemainingMin,
} from "../../../utilities/utility";
import { toast } from "react-toastify";
import CustomCircularP from "../../widgets/customCircularP";
import YesNoDialog from "../../widgets/ratulModal/YesNoDialog";
import { useLocation } from "react-router-dom";

const ALive = () => {
  
  console.log("Alive.js")
  const location = useLocation();
  const STARTED = "started";
  const UPCOMING = "upcoming";
  const COMPLETED = "completed";
  const LIVE = "LIVE";
  const IN_PROGRESS = "In progress";

  const PAGE_LOADING = "page_loading";
  const PAGE_NO_ASSESSMENT = "page_no_assessment";
  const PAGE_ASSESSMENT = "page_assessment";

  const PAGE_GO_ENTER_NAME = "page_go_enter_name";
  const PAGE_GO_COMPLETED = "page_go_completed";

  const [pageState, setPageState] = useState(PAGE_LOADING);
  const loc = document.location.href.replace(/\/+$/, "");
  const keysUrl = loc.split("/");
  const linkCode = keysUrl[5];
  const [name, setName] = useState("");
  const [status, setStatus] = useState("");
  const [timeToCount, setTimeToCount] = useState(0);
  //let timeToCount = 0

  const [cd, setCd] = useState(Date.now());
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [socket, setSocket] = useState(null);
  const [ainfo, setAinfo] = useState({});
  const [cinfo, setCinfo] = useState({});
  const [myqns, setMyqns] = useState([]);
  const [ended, setEnded] = useState(false);
  const [currentQn, setCurrentQn] = useState(1);
  const [dopen, setDopen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState("");

  useEffect(() => {
    const newSocket = io(API_ENDPOINT, { transports: ["websocket"] });
    setSocket(newSocket);
    return () => newSocket.close();
  }, [setSocket]);

  useEffect(() => {
    if (socket !== null) {
      socket.on("end-" + linkCode, (m) => {
        window.location.reload();
      });
    }
  }, [socket]);

  useEffect(()=>{
    if(socket !== null){
      socket.on("timeover_" + linkCode, (m) => {
        if(m.name == name)
          window.location.reload();
    });}
  }, [socket])

  useEffect(() => {
    const preventBack = () => {
      window.history.forward();
    };

    setTimeout(preventBack, 0);

    // Setting event handler
    window.onunload = preventBack;

    // Cleanup logic
    return () => {
      window.onunload = null;
    };
  }, []);

  useEffect(() => {
    /*
            Here candidate session is Checked
        */
    if (isCandidateExists()) {
      let cn = getCandidateName(); console.log(cn,"kkkkkkkk",linkCode);
      if (cn.linkCode === linkCode) {
        console.log("here");
        setName(cn.name);
        loadAssessment();
      } else {
        setPageState(PAGE_GO_ENTER_NAME);
      }
    } else {
      setPageState(PAGE_GO_ENTER_NAME);
    }
  }, []);

  useEffect(() => {
    console.log("changed",name);
    checkCandidateStatus();
  }, [name]);

  async function checkCandidateStatus() {
    try {
      axios
        .post(
          API_ENDPOINT + "user/get-candidate",
          { name,linkCode },
          HEADER_TOKEN
        )
        .then((res) => {
          let d = res.data;
          if (!d.success) {
            let C = d.message;
            console.log("redirect",C)
            setCinfo(C);
            if (C.status === "Completed") {
              document.location.href = "/assessment/" + linkCode + "/answer-sheet/" + encodeURI(name);
              //console.log("redirect")
            }
          }
        });
    } catch (error) {
      console.error("Error fetching status:", error);
    }
  }

  useEffect(() => {
    /*
           STATUS: UPCOMING, STARTED, COMPLETED
           Here candidate session already exists
       */
    if (status !== "") {
      if (status === UPCOMING) {
        setPageState(PAGE_GO_ENTER_NAME);
      } else if (status === COMPLETED) {
        setPageState(PAGE_GO_COMPLETED);
      } else {
        //Here we are in the assessment page

        //Notify to Trainer u r Live
        if (socket !== null) {
          let d = {
            name: name,
            status: LIVE,
            score: 0,
            linkCode: ainfo.linkCode,
            numAttempted: 0,
          };
          socket.emit("goLive", d);         
        
          let ans = {};
          ans.name = name;
          ans.title = ainfo.title;
          ans.duration = ainfo.duration;
          ans.linkCode = linkCode;
          ans.config = ainfo.config;
          ans.answers = ainfo.questions;
          ans.numQns = ainfo.numQns;
          ans.score = 0;
          ans.numAttempted = 0;
          ans.status = "Draft";
          axios.post(API_ENDPOINT + "user/save-answers", ans).then((res) => {
            if(d.message == "deleted"){
              deleteCandidate();
              window.location.reload();
            }
            console.log("waiting saved",ans)
          });

        }
        let ad = ainfo.duration;
        let sd = new Date(ainfo.startDate);
        let nd = new Date();
        if(ainfo.flexible === false) {
          let remainingTime = (nd.getTime() - sd.getTime()) / (1000 * 60);
          setTimeToCount(ad - remainingTime);
        }
        else{
          const remMin = getRemainingMin(ainfo.endDate); console.log(remMin,"remMin");
          if(remMin > ad)
            setTimeToCount(ad);
          else if(remMin > 0)
            setTimeToCount(remMin);
          //else
            //window.location.reload();
        }
        if (answerExists()) {
          let asm = getAnswers();
          let size = asm.questions.filter((as) => as.status === "attempted");
          let indc = size.length;
          if (asm.linkCode === linkCode) {
            if (!ainfo.config.allowBack) {
              if (indc === ainfo.numQns) {
                setCurrentQn(indc - 1);
              } else {
                if (indc < ainfo.numQns) {
                  setCurrentQn(indc);
                }
              }
            }
            let mas = asm.questions;
            setMyqns(mas);

            let allCorrect = mas.filter((r) => r.choiceCorrect);
            let dto = {
              name: name,
              linkCode: linkCode,
              status: IN_PROGRESS,
              score: allCorrect.length,
              numAttempted: indc,
            };
            socket.emit("goLive", dto);

            setPageState(PAGE_ASSESSMENT);
          } else {
            createAnswerSheet(ainfo);
          }
        } else {
          createAnswerSheet(ainfo);
        }

        //setPageState(PAGE_ASSESSMENT)
      }
    }
  }, [status]);

  useEffect(() => {
    if (Object.keys(ainfo).length > 0) {
      //   if (ainfo.flexible) {
      //     setPageState(PAGE_NO_ASSESSMENT);
      //   } else {
      //     setStatus(ainfo.status);
      //   }
      setStatus(ainfo.status);
    }
  }, [ainfo]);

  useEffect(() => {
    if (pageState === PAGE_GO_COMPLETED) {
      document.location.href = "/assessment/" + linkCode + "/answer-sheet/" + encodeURI(name);
    } else if (pageState === PAGE_GO_ENTER_NAME) {
      document.location.href = "/assessment/" + linkCode;
    }
  }, [pageState]);

  function loadAssessment() {
    axios
      .post(API_ENDPOINT + "student/get-assessment", { linkCode })
      .then((res) => {
        let d = res.data;
        if (d.success) {
          setAinfo(d.message);
        } else {
          toast(d.message);
          setPageState(PAGE_NO_ASSESSMENT);
        }
      });
  }
  function createAnswerSheet(asm) {
    let sqns = asm.questions;
    let myqnsA = [];
    if (asm.config.shuffleQuestions) {
      myqnsA = shuffleFisherYates(sqns);
    }

    if (asm.config.shuffleOptions) {
      myqnsA.map((s, i) => {
        s.options = shuffleFisherYates(s.options);
      });
    }
    if (myqnsA.length === 0) myqnsA = sqns;
    myqnsA.map((q, i) => {
      q.status = "unattempted";
      q.qno = i + 1;
    });
    setMyqns(myqnsA);
    setPageState(PAGE_ASSESSMENT);
  }
  const Completionist = () => <span>00:00</span>;
  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {      
      if(ainfo.flexible)
        finishAction(true);
      else
        onFinishAssessment();
      return <Completionist />;
    } else {
      // Render a countdown
      return (
        <span>
          {pad(hours)}:{pad(minutes)}:{pad(seconds)}
        </span>
      );
    }
  };
  const onFinishAssessment = () => {
    console.log("onFinishAssessment Alive")
    setDopen(true);
  };
  function pad(n) {
    return n < 10 ? "0" + n : n;
  }
  const onNoResponse = () => {
    setDopen(false);
  };
  useEffect(() => {
    if (ended) {
      finishAction(true);
    }
  }, [ended]);
  
  const onYesResponse = () => {
    setDopen(false);
    finishAction(true);
  };
  function finishAction(status=false) {
    console.log(status,"status")
    let ans = {};
    ans.name = name;
    ans.title = ainfo.title;
    ans.duration = ainfo.duration;
    ans.linkCode = linkCode;
    ans.config = ainfo.config;
    ans.answers = myqns;
    ans.numQns = ainfo.numQns;
    if(status){
      setIsSubmitting(true);
      ans.status = "Completed";
    }
    else
    ans.status = "Draft";
    let allCorrect = myqns.filter((r) => r.choiceCorrect);
    let numA = myqns.filter((r) => r.status === "attempted").length;
    ans.score = allCorrect.length;
    ans.numAttempted = numA;
    axios.post(API_ENDPOINT + "user/save-answers", ans).then((res) => {
      let d = res.data;
      if(d.message == "deleted"){
        deleteCandidate();
        window.location.reload();
      }
      else if(status)
      {
        setIsSubmitting(false);
        if (d.success) {
          //saveAnswers({name: name, completed: true, linkCode: linkCode, questions: myqns})
          document.location.href = "/assessment/" + linkCode + "/answer-sheet/" + encodeURI(name);
        }
      }

    });
    if(status === true)
      return { shouldRepeat: false };
  }
  return (
    <div className="container-assessment">
      <CustomCircularP show={pageState === PAGE_LOADING} />
      <YesNoDialog
        dopen={dopen}
        message="Are you sure you want to Finish?"
        onNoResponse={onNoResponse}
        onYesResponse={onYesResponse}
        setDopen={setDopen}
      />
      {pageState === PAGE_ASSESSMENT ? (
        <>          
        {/* <!-- Left Panel --> */}
        <div className="left-panel">
            <div className="logo">
                <img src={appLogo} alt="tykhere Logo" />
            </div>

            <div className="candidate-info">
                <img src={appLogo} class="hide-on-large" alt="tykhere Logo" style={{width: '85%'}} />
                <p>Candidate Name : {name}</p>
                <p className="subject">{ainfo.title}</p>
                <p className="details">{ainfo.numQns} Questions | {ainfo.duration} Minutes</p>
            </div>
            {/* <div className="timer">
            <CircleTimer duration={timeToCount*60} />
            </div> */}
            <div className='count_c'>
                <Countdown date={cd + timeToCount*60000} renderer={renderer}></Countdown>
                <div className='count_c_l' style={{fontSize: 14, fontWeight: 400}}>hh:mm:ss</div>
            </div>
        </div>

        {/* <!-- Right Panel --> */}
        <div className="right-panel">
              {myqns.map((q, i) => (
                <QuestionBox
                  key={i}
                  socket={socket}
                  currentQn={currentQn}
                  setCurrentQn={setCurrentQn}
                  num={ainfo.numQns}
                  finishAction={finishAction}
                  config={ainfo.config}
                  linkCode={linkCode}
                  name={name}
                  qno={i + 1}
                  ma={myqns}
                  setMa={setMyqns}
                  question={q}
                  show={i + 1 === currentQn}
                  setImageUrl={setImageUrl} // Pass setImageUrl
                  setIsOpen={setIsOpen} // Pass setIsOpen
                  imageUrl={imageUrl} // Pass setImageUrl
                  isOpen={isOpen} // Pass setIsOpen
                />
              ))}
            
            <AssessmentInfo
              socket={socket}
              config={ainfo.config}
              onFinishAssessment={onFinishAssessment}
              linkCode={linkCode}
              name={name}
              a={ainfo}
              ma={myqns}
              setMa={setMyqns}
              currentQn={currentQn}
              setCurrentQn={setCurrentQn}
              num={ainfo.numQns}
            />
        </div>
        </>
      ) : (
        <div style={{ fontSize: "20px", textAlign: "center", padding: "16px" }}>
          {/* No Assessment Found! */}
        </div>
      )}
      

{/* Global Image Modal */}
{isOpen && imageUrl && (
  <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ backgroundColor: "rgba(0, 0, 0, 0.7)" }}
    onClick={() => setIsOpen(false)}
  >
    <div
      className="modal-dialog modal-dialog-centered"
      role="document"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="modal-content" style={{height:'400px'}}>
      <div class="modal-header"></div>
        {/* Close Button */}
        <button
          type="button"
          className="btn-close position-absolute top-0 end-0 m-2"
          aria-label="Close"
          onClick={() => setIsOpen(false)}
        ></button>

        {/* Image */}
        <div className="modal-body text-center d-flex justify-content-center align-items-center pb-5">
          <img
            src={imageUrl}
            alt="Popup"
            className="img-fluid rounded"
            style={{ maxHeight: "300px", objectFit: "contain" }}
          />
        </div>
      </div>
    </div>
  </div>
)}



    </div>
  );
};
export default ALive;
